"use client";

import { useEffect, useState } from "react";
import { Box, Text, Button, ButtonGroup } from "@chakra-ui/react";

import { cookieConsentStyles } from "styles/CookieConsentStyle";

type ConsentStatus = "accepted" | "rejected" | "custom";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);
  const [showPreferences, setShowPreferences] = useState(false);

  // useEffect(() => {
  //   const consent = localStorage.getItem("cookie_consent");
  //   if (!consent) setVisible(true);
  // }, []);

  useEffect(() => {

    const isMobileApp = /aajump-app/i.test(navigator.userAgent);

    if (isMobileApp) {
      console.log("App detectado via UserAgent");
      return;
    }

    const consent = localStorage.getItem("cookie_consent");
    if (!consent) setVisible(true);
  }, []);

  const saveConsent = (
    status: ConsentStatus,
    preferences?: Record<string, boolean>,
  ) => {
    localStorage.setItem("cookie_consent", status);

    if (preferences) {
      localStorage.setItem("cookie_preferences", JSON.stringify(preferences));
    }

    setVisible(false);
    setShowPreferences(false);
  };

  if (!visible) return null;

  return (
    <>
      <Box {...cookieConsentStyles.cookieBackdrop} />

      <Box {...cookieConsentStyles.cookieContainer}>
        <Text {...cookieConsentStyles.cookieTitle}>
          Controle sua privacidade
        </Text>

        <Text {...cookieConsentStyles.cookieText}>
          Nosso site usa cookies para melhorar a navegação, analisar o tráfego e
          personalizar conteúdos e anúncios. Compartilhamos dados com parceiros
          como Google.
        </Text>
        <Box {...cookieConsentStyles.cookieLinks}>
          <a href="/institucional/politicas-de-privacidade">
            • Política de Privacidade
          </a>
          <a href="/institucional/politicas-de-privacidade">• Termos de Uso</a>
        </Box>

        <Box {...cookieConsentStyles.cookieActions}>
          <Box {...cookieConsentStyles.cookieButtons}>
            <Button
              {...cookieConsentStyles.cookieButton}
              {...cookieConsentStyles.cookieButtonSecondary}
              onClick={() => saveConsent("rejected")}
            >
              Rejeitar
            </Button>

            <Button
              {...cookieConsentStyles.cookieButton}
              {...cookieConsentStyles.cookieButtonPrimary}
              onClick={() => saveConsent("accepted")}
            >
              Aceitar
            </Button>
          </Box>
        </Box>
      </Box>
    </>
  );
}
